import { render, staticRenderFns } from "./EditLabels.vue?vue&type=template&id=d824fab0&"
import script from "./EditLabels.vue?vue&type=script&lang=js&"
export * from "./EditLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports